enum WeatherDataSourceEnum {
  METEOBLUE = 'meteoblue',
  CLIMATEMPO = 'climatempo'
}

export default WeatherDataSourceEnum;
